function doPPDPagination(resultCount, currentPage, numPerPage) {
    var $pagination = $('#pagination_search');

    console.log('Page results count TEST : %o', resultCount);

    if (resultCount !== null && resultCount > numPerPage) {
        $pagination.pagination('destroy');
        $pagination.pagination('updateItems', resultCount);
        $pagination.pagination('drawPage', currentPage);
        $pagination.show();
    } else {
        $pagination.hide();
    }
}
function DoPPDAjaxSearch(pageNo, pageId) {
    var categoryString = "";
    var deliveryString = "";
    var applicationString = "";
    var bandString = "";
    var numPerPage = $("#numPerPage").val();
    var keywords = $("#searchboxCourses").val();
    var hideCategory = $("#categoryHidden").val();
    //console.log("Hide category: " + hideCategory);
    if ($("#chosenCategory").val() != "" && hideCategory == "True") {
        categoryString = $("#chosenCategory").val();
    }
    else {
        var categoryChecks = $("input[type='checkbox']:checked[data-group='CourseCategory']");
        $.each(categoryChecks, function (key, value) {
            var isLastElement = key == categoryChecks.length - 1;
            if (!isLastElement) {
                categoryString += value.value + ",";
            }
            else {
                categoryString += value.value;
            }
        });
        console.log("Category string: " + categoryString);
    }
    var deliveryChecks = $("input[type='checkbox']:checked[data-group='CourseDeliveryMethod']");
    $.each(deliveryChecks, function (key, value) {
        var isLastElement = key == deliveryChecks.length - 1;
        if (!isLastElement) {
            deliveryString += value.value + ",";
        }
        else {
            deliveryString += value.value;
        }
    });
    var bandChecks = $("input[type='checkbox']:checked[data-group='CourseBand']");
    $.each(bandChecks, function (key, value) {
        var isLastElement = key == bandChecks.length - 1;
        if (!isLastElement) {
            bandString += value.value + ",";
        }
        else {
            bandString += value.value;
        }
    });
    var applicationChecks = $("input[type='checkbox']:checked[data-group='CourseApplicationProcessType']");
    $.each(applicationChecks, function (key, value) {
        var isLastElement = key == applicationChecks.length - 1;
        if (!isLastElement) {
            applicationString += value.value + ",";
        }
        else {
            applicationString += value.value;
        }
    });

    //console.log("cat string %o", categoryString);
    //console.log("delivery string %o", deliveryString);
    //console.log("application string %o", applicationString);
    //console.log("band string %o", bandString);
    $.ajax({
        url: "/Umbraco/Surface/PPD/GetCourseItems",
        method: 'post',
        data: {
            pageId: pageId, categoryId: categoryString, deliveryId: deliveryString, applicationId: applicationString, bandId: bandString, recordsPerPage: numPerPage, resultPage: pageNo, keywords: keywords
        },
    }).done(function (result) {
        //console.log("Processing ajax results : %o", result);
        var source = document.getElementById("courseListingTemplate").innerHTML;
        courseListingTemplate = Handlebars.compile(source);
        var html = courseListingTemplate(result);
        $('#course_results').html(html);
        doPPDPagination(result.resultTotal, pageNo, numPerPage);

        // Order by drop down
        //var selector = '#orderField option[value=' + searchParams.orderField + ']';
        //$(selector).attr('selected', 'selected');
    }
    );
}
function initPPDListing(pageID) {
    var categoryString = "";
    var deliveryString = "";
    var applicationString = "";
    var bandString = "";
    var numPerPage = $("#numPerPage").val();
    var keywords = $("#searchBoxCourses").val();
    if ($("#chosenCategory").val() != "") {
        categoryString = $("#chosenCategory").val();
    }
    else {
        var categoryChecks = $("input[type='checkbox']:checked[data-group='CourseCategory']");
        $.each(categoryChecks, function (key, value) {
            var isLastElement = key == categoryChecks.length - 1;
            if (!isLastElement) {
                categoryString += value.value + ",";
            }
            else {
                categoryString += value.value;
            }
        });
    }
    var deliveryChecks = $("input[type='checkbox']:checked[data-group='CourseDeliveryMethod']");
    $.each(deliveryChecks, function (key, value) {
        var isLastElement = key == deliveryChecks.length - 1;
        if (!isLastElement) {
            deliveryString += value.value + ",";
        }
        else {
            deliveryString += value.value;
        }
    });
    var bandChecks = $("input[type='checkbox']:checked[data-group='CourseBand']");
    $.each(bandChecks, function (key, value) {
        var isLastElement = key == bandChecks.length - 1;
        if (!isLastElement) {
            bandString += value.value + ",";
        }
        else {
            bandString += value.value;
        }
    });
    var applicationChecks = $("input[type='checkbox']:checked[data-group='CourseApplicationProcessType']");
    $.each(applicationChecks, function (key, value) {
        var isLastElement = key == applicationChecks.length - 1;
        if (!isLastElement) {
            applicationString += value.value + ",";
        }
        else {
            applicationString += value.value;
        }
    });

    //console.log("cat string %o", categoryString);
    //console.log("delivery string %o", deliveryString);
    //console.log("application string %o", applicationString);
    $.ajax({
        url: "/Umbraco/Surface/PPD/GetCourseItems",
        method: 'post',
        data: {
            pageId: pageID, categoryId: categoryString, deliveryId: deliveryString, applicationId: applicationString, bandId: bandString, recordsPerPage: numPerPage, resultPage: 1, keywords: keywords
        },
    }).done(function (result) {
        //console.log('done ', result);
        var source = document.getElementById("courseListingTemplate").innerHTML;
        courseListingTemplate = Handlebars.compile(source);
        var html = courseListingTemplate(result);
        $('#course_results').html(html);
        //console.log("I am here");
        $('#pagination_search').pagination({
            items: result.resultTotal,
            itemsOnPage: numPerPage,
            cssStyle: 'light-theme',
            onPageClick: function (pageNumber, event) {
                //console.log('page %o, contents : %o', pageNumber, event);
                DoPPDAjaxSearch(pageNumber, pageID);
                //scrollToAnchorOffset('#topOfSearch', -120);
            },
            onInit: function () {
                //console.log('Init paging');
                var resultCount = 0;
                if (result.resultTotal !== null) {
                    resultCount = result.resultTotal;
                }
                doPPDPagination(resultCount, 1, numPerPage);
            }
        });
        $(".search__aggregation--ppd input[type='checkbox']").click(function () {
            //console.log("Checkbox clicked");
            DoPPDAjaxSearch(1, pageID);
        });
        $("#searchBoxCoursesSearch").click(function () {
            DoPPDAjaxSearch(1, pageID);
        });
        $("#searchBoxCoursesClear").click(function () {
            $("#searchboxCourses").val("");
            DoPPDAjaxSearch(1, pageID);
        });
    }).fail(function (result) {
        console.error('Failed', result);
        // reject(result);
    });
}